import React, { useContext, useEffect } from 'react'
import { settingsContext } from '../../Context/settingsProvider'
import ErrorIcon from '@mui/icons-material/CancelOutlined';
import SuccessIcon from '@mui/icons-material/CheckCircle';

export default function Notifications() {
    const {notifications, setNotifications} = useContext(settingsContext)
    console.log(notifications)

    return !!notifications.length && (
        <div className='fixed top-0 right-0 left-0 flex flex-col z-4 p-4 pt-1 gap-2'>
            {notifications.map(notif => (
                <SingleNotification notif={notif} setNotifications={setNotifications} />
            ))}
        </div>
    )
}
    
function SingleNotification({ notif, setNotifications }){
    useEffect(() => {
        console.log('change', notif.id)
        setTimeout(() => {
            setNotifications(ntfs => ntfs.filter(ntf => ntf.id != notif.id))
        }, 3000)
    }, [notif.id])

    return (
        <div className='w-full p-2 rounded-sm bg-[#525252] z-[999999] shadow-md flex gap-2 items-center'>
            {notif.type == 'success' ? <SuccessIcon style={{color: '#198754', fontSize: 25}}>Filled</SuccessIcon> : <ErrorIcon style={{color: 'red', fontSize: 25}}>Filled</ErrorIcon> }
            <p className='text-white text-[20px]'>{notif.text}</p>
        </div>
    )
}